import { Link, useLocation, useNavigate } from "react-router-dom";
import { MouseEvent, useRef } from "react";
import LangChange from "../headerWeb/langChange";
import { useAuthContext } from "components/context/authContext";
import { useTranslation } from "react-i18next";
import { useMutation } from "@tanstack/react-query";
import { logoutApi } from "components/api/user";
import { alertControl, modalControl, successControl } from "util/commAction";
import LoginModal from "components/modal/login";
import "../header.scss";

type IProps = {
  text: string;
};

export default function MBHeader({ text }: IProps) {
  const { isLogin, setIsLogin } = useAuthContext();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const { lodInf } = useAuthContext();

  const menuRef = useRef<HTMLDivElement>(null);

  const handleOpen = (e: MouseEvent<HTMLButtonElement>) => {
    if (menuRef.current) {
      menuRef.current.className = "mb-menu visible";
    }
  };

  const handleClose = (e: MouseEvent<HTMLLIElement>) => {
    if (menuRef.current) {
      menuRef.current.className = "mb-menu";
    }
  };

  const logoutMutation = useMutation({
    mutationFn: logoutApi,
    onSuccess: (res) => {
      if (res) {
        successControl({
          status: res.status,
          success: () => {
            const removeItem = ["userInf", "lodInf"];
            removeItem.forEach((item) => {
              localStorage.removeItem(item);
            });
            setIsLogin(false);
            sessionStorage.removeItem("isLogin");
            if (menuRef.current) {
              menuRef.current.className = "mb-menu";
            }
          },
        });
      }
    },
  });

  const handleLogOut = () => {
    alertControl({
      isOpen: true,
      inner: t("alr_logout"),
      cncl_btn: true,
      click: () => {
        logoutMutation.mutate();
      },
    });
  };

  // logo, 객실선택 후 객실명 , 로그인, 회원가입 뒤록가기 아이콘
  const btnIcon =
    pathname === "/"
      ? "logo"
      : pathname.includes("login") || pathname.includes("join")
      ? "back"
      : "";

  return (
    <>
      <div className="header-mb">
        {/* 모바일 헤더 */}
        <div className="flex justify-between ">
          <div className="center gap-2">
            <button
              data-icon={btnIcon}
              onClick={() => {
                // lodNm 있을시 홈으로 가기
                // icon 뒤로가기 있을시 뒤로 가기 라우터 이동시

                if (btnIcon !== "logo") {
                  navigate(-1);
                }
              }}
            />
            {btnIcon !== "back" && (
              <h3
                className="cursor-pointer mt-1"
                onClick={() => {
                  navigate("/" + lodInf?.lodNo);
                }}
              >
                {pathname === "/" ? "" : lodInf?.lodNm}
              </h3>
            )}
          </div>
          {/* <h3>{text}객실명</h3> */}
          <button className="btn-menu" onClick={handleOpen} />
        </div>
        <div className="mb-menu" ref={menuRef}>
          <div>
            {/* LEFT MENU HEADER */}
            <ul className="flex justify-between items-center relative h-[72px] px-[12px]">
              <li>
                <LangChange height={28} styles="left-[24px] top-[22px]" />
              </li>
              <li onClick={handleClose}>
                <button className="btn-close" />
              </li>
            </ul>

            <ul>
              <li onClick={handleClose}>
                <Link
                  to="/"
                  className={pathname === "/" + lodInf?.lodNo ? "on" : ""}
                >
                  {t("lst_hd_hm")}
                </Link>
              </li>
              <li
                onClick={(e) => {
                  /* 예약조회  로그이인시 마이페이지 로그인 모달창  */
                  if (isLogin) {
                    navigate("/mypage/resv");
                  }
                  if (!isLogin) {
                    //로그인 모당창 오픈
                    modalControl({
                      isOpen: true,
                      chckBtn: false,
                      styles: "modal-full",
                      inner: <LoginModal nextPath="/mypage/resv" />,
                    });
                  }
                  handleClose(e);
                }}
              >
                {t("lst_hd_rsvt")}
              </li>

              {/* 로그인 전 */}
              {!isLogin && (
                <>
                  <li
                    className={pathname.includes("join") ? "on" : ""}
                    onClick={handleClose}
                  >
                    <Link to="/join">{t("lst_hd_sgn")}</Link>
                  </li>
                  <li
                    className={pathname.includes("login") ? "on" : ""}
                    onClick={(e) => {
                      if (pathname.includes("book")) {
                        modalControl({
                          isOpen: true,
                          chckBtn: false,
                          styles: "modal-full",
                          inner: <LoginModal nextPath={pathname} />,
                        });
                      }
                      if (!pathname.includes("book")) {
                        navigate("/login");
                      }
                      handleClose(e);
                    }}
                  >
                    {t("lst_hd_lgi")}
                  </li>
                </>
              )}

              {/* 로그인 후 */}
              {isLogin && (
                <li className="mypage">
                  <h2
                    className={
                      pathname.includes("mypage") ? "text-blue-300" : ""
                    }
                  >
                    {t("lst_hd_mpg")}
                  </h2>
                  <ul>
                    <li
                      className={pathname === "/mypage" ? "text-blue-300" : ""}
                      onClick={handleClose}
                    >
                      <Link to="/mypage" className="font-16 h-[2.5rem]">
                        {t("lst_hd_us_info")}
                      </Link>
                    </li>
                    <li
                      className={
                        pathname.includes("mypage/resv") ? "text-blue-300" : ""
                      }
                      onClick={handleClose}
                    >
                      <Link to="/mypage/resv" className="font-16 h-[2.5rem]">
                        {t("lst_hd_bk")}
                      </Link>
                    </li>
                    {/* <li>
                      <Link to="" className="font-16 h-[2.5rem]">
                        {t("lst_hd_htl")}
                      </Link>
                    </li>
                    <li>
                      <Link to="" className="font-16 h-[2.5rem]">
                        {t("lst_hd_sns")}
                      </Link>
                    </li> */}
                  </ul>
                </li>
              )}
            </ul>
            <div className="btn-logout">
              <button type="button" onClick={handleLogOut}>
                {t("lst_hd_lgo")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
